import { render, staticRenderFns } from "./statement-detail.vue?vue&type=template&id=7387f9bf&scoped=true"
import script from "./statement-detail.vue?vue&type=script&lang=js"
export * from "./statement-detail.vue?vue&type=script&lang=js"
import style0 from "./statement-detail.vue?vue&type=style&index=0&id=7387f9bf&prod&lang=less&scoped=true"
import style1 from "./statement-detail.vue?vue&type=style&index=1&id=7387f9bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7387f9bf",
  null
  
)

export default component.exports